var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.result)+" "),_c('v-btn',{on:{"click":function($event){return _vm.execute()}}},[_vm._v("パーツの画像パスを登録する")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }